export default __webpack_public_path__ + "static/media/go-to-top.d5741cfe.svg";